import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import './Settings.css';

export default function Settings() {
  const { t, i18n } = useTranslation();
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'en', label: '🇬🇧 English' },
    { code: 'my', label: '🇲🇲 မြန်မာ' },
  ];

  const themes = [
    { value: 'light', label: '☀️ Light', icon: '☀️' },
    { value: 'dark', label: '🌙 Dark', icon: '🌙' },
    { value: 'system', label: '💻 System', icon: '💻' },
  ];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <div className="settings" ref={dropdownRef}>
      <button
        className="settings-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Settings"
        aria-expanded={isOpen}
      >
        <span className="settings-icon">⚙️</span>
      </button>

      {isOpen && (
        <div className="settings-dropdown">
          <div className="settings-header">
            <h2 className="settings-title">{t('settings.title')}</h2>
            <button
              className="settings-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close settings"
            >
              ✕
            </button>
          </div>

          <div className="settings-content">
            <div className="settings-section">
              <h3 className="settings-heading">{t('settings.language')}</h3>
              <div className="settings-options">
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    className={`settings-option ${i18n.language === lang.code ? 'active' : ''}`}
                    onClick={() => {
                      i18n.changeLanguage(lang.code);
                    }}
                  >
                    {lang.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="settings-divider"></div>

            <div className="settings-section">
              <h3 className="settings-heading">{t('settings.theme')}</h3>
              <div className="settings-options">
                {themes.map((themeOption) => (
                  <button
                    key={themeOption.value}
                    className={`settings-option ${theme === themeOption.value ? 'active' : ''}`}
                    onClick={() => {
                      setTheme(themeOption.value as 'light' | 'dark' | 'system');
                    }}
                  >
                    {themeOption.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 